import { useState, useEffect } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useZonesStore } from "@/store/zones/zones.store";
import { Zones } from "@/models/database/zones/Zones.model";

const useSingleZone = (slug: string) => {
  const [zoneItem, setZoneItem] = useState<Zones | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const zoneStore = useZonesStore();

  useEffect(() => {
    const fetchZoneItem = async () => {
      try {
        const storedZoneItem = zoneStore.getZoneBySlug(slug);
        if (storedZoneItem) {
          setZoneItem(storedZoneItem);
          setLoading(false);
          return;
        }

        const querySnapshot = await collectionRef
          .zones(brand.tenantId)
          .where("slug", "==", slug)
          .limit(1)
          .get();

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];

          setZoneItem({
            ...doc.data(),
          } as Zones);
        } else {
          setError(Error("No zones item found with the given slug"));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchZoneItem();
  }, [slug]);

  return { zoneItem, loading, error };
};

export default useSingleZone;
